import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import Checkbox from "@material-ui/core/Checkbox";
import { FormControlLabel } from "@material-ui/core/";
import Button from "../Button";

import EnrollmentTable, { DownloadCSVButton } from "./EnrollmentTable";

const HeldEnrollments = ({
  enrollments,
  selectedView,
  fetchAddNote,
  fetchEnrollments,
  fetchMoreEnrollments,
  fetchCancelEnrollments,
  resubmitEnrollment,
  fetchUpdateEnrollmentName,
  rerunCredit,
  adminUser,
  pageHeld,
  limit,
  hasNextHeld,
  totalHeld,
}) => {
  const [includeForwardStarts, setIncludeForwardStarts] = useState(true);
  const [disabled, setDisabled] = useState(false);

  const searchCriteria = { status: "hold", include_forward_starts: includeForwardStarts };

  useEffect(async () => {
    if (selectedView == "Held Enrollments") {
      await fetchEnrollments(searchCriteria, true);
    }
  }, [selectedView]);

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={includeForwardStarts}
              onChange={async (e) => {
                const val = e.target.checked;
                setIncludeForwardStarts(val);
                await fetchEnrollments({ status: "hold", include_forward_starts: val }, true);
              }}
              name="chkIncludeForwardStarts"
            />
          }
          label="Include Forward Starts"
        />
        <DownloadCSVButton
          enrollments={enrollments}
        />
      </div>
      <EnrollmentTable
        isHold={true}
        adminUser={adminUser}
        searchCriteria={searchCriteria}
        enrollments={enrollments}
        fetchAddNote={fetchAddNote}
        fetchEnrollments={fetchEnrollments}
        fetchCancelEnrollments={fetchCancelEnrollments}
        resubmitEnrollment={resubmitEnrollment}
        fetchUpdateEnrollmentName={fetchUpdateEnrollmentName}
        rerunCredit={rerunCredit}
      />

      {hasNextHeld && (
        <Button
          onClick={async () => {
            setDisabled(true);
            await fetchMoreEnrollments(searchCriteria, true);
            setDisabled(false);
          }}
          color="primary"
          variant="contained"
          style={{
            marginRight: 20,
            marginTop: 10,
          }}
          disabled={disabled}
        >
          Load More
        </Button>
      )}

      {enrollments.length > 0 && enrollments.length !== totalHeld ? (
        <div style={{ float: "right", marginTop: "10px" }}>
          Downloaded {(pageHeld + 1) * limit} of {totalHeld} enrollments
        </div>
      ) : (
        enrollments.length > 0 && (
          <div style={{ float: "right", marginTop: "10px" }}>
            Downloaded all {totalHeld} enrollments
          </div>
        )
      )}
    </div>
  );
};

HeldEnrollments.propTypes = {
  enrollments: PropTypes.array,
};

export default HeldEnrollments;
